<template>
  <div class="form-row">
    <div class="form-group col-12">
      <p class="font-weight-bold">Select Video</p>
      <div class="models-wrapper">
        <div v-for="(model, key) in getVideos"
            :key="key"
            class="model-item"
            :class="{'active': activeModel === model.name }"
        >
          <div class="col-1">
            <button
              @click="playSelectedVideo(model)"
              class="btn btn-outline-success"
            >
              <i class="fa fa-play"></i>
            </button>
          </div>

          <div class="col-1">
            <button
              @click="changeSelectedModel(key, model)"
              class="btn btn-primary"
            >
              Select
            </button>
          </div>
          <p>{{ model.name }}</p>
        </div>
      </div>
       <div id="preview-div" class="preview-div">
         <button @click="hideVideoPreview()" >&times;</button>
          <video
            controls
            id="selectedVideoPreview"
            src=""
          ></video>
        </div>
    </div>
  </div>
</template>
<script>

import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  components: {},
  data () {
    return {
      activeModel: 'Select Model',
      positionOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      rotationOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
    }
  },
  created() {
    this.listVideos();
  },
  methods: {
    ...mapActions(["listVideos"]),
    changeSelectedModel (index, model) {
      this.activeModel = model.name
      this.allCharacters = this.characters.map((char) => ({ ...char, active: false }))
      // this.$store.dispatch('updateCharacters', this.characters.map((char) => ({ ...char, active: false,characterElements:[] })))
      let selectedOne = {
        objectId: Math.floor(Date.now() / 1000),
        type: "Video",
        objectName: model.name,
        objectDbHash: index,
        displayType: model.typeOfDisplay || 'Screen',
        objectDescription: model.description || '',
        objectUrl: model['video'].videoURL,
        presenceDuration: model.duration,
        startTime: 0,
        maximumDistance: 0,
        minimumDistance: 0,
        endTime: model.duration,
        duration: model.duration,
        presenceDuration: model.duration,
        layer: model.layer || 1,
        objectSizeDelta: {
          width: model.mediaWidth || 200,
          height: model.mediaHeight || 200
        },
        scale: 0.5,
        simpleTransform: true,
        objectTransformSimple: {
            horizontal: model.horizontalAlignment || 'center',
            vertical: model.verticalAlignment || 'center',
            offsetHorizontal: model.offsetHorizontal || 0,
            offsetVertical: model.offsetVertical || 0,
        },
        positionOfOrigin: model.hasOwnProperty('positionOfOrigin') ? model.positionOfOrigin : this.positionOfOrigin,
        rotationOfOrigin: model.hasOwnProperty('rotationOfOrigin') ? model.rotationOfOrigin : this.rotationOfOrigin,
        videoSettings: {
          videoLoop: false,
          playbackSpeed: 1,
          volumeVideo: 1
        },
        active: true,
      };
      this.$store.dispatch('updateCharacters', [
        ...this.allCharacters,
        selectedOne
      ])
      this.$emit('triggerSelectedVideo', { index, model })
      this.$emit('closePopup')
    },
    playSelectedVideo(video) {
      document.getElementById("preview-div").style.display = 'flex';
      document.getElementById("selectedVideoPreview").src = video.video.videoURL;
     document.getElementById("selectedVideoPreview").play();
    },
    hideVideoPreview() {
      document.getElementById("selectedVideoPreview").pause();
      document.getElementById("preview-div").style.display = 'none';
    }
  },
  mounted () {},
  watch: {},
  computed: {
    ...mapGetters(["getVideos"]),
    ...mapState([ 'videos', 'characters'])
  }
}
</script>
<style scoped lang="scss">

button {
  width: 75px;
}

i {
  width: 100%;
}


.preview-div {
  position: fixed;
  width: 50vw;
  display: none;
  align-items: center;
  justify-content: center;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #151515;
  border-radius: 10px;
  z-index: 1000;

  button {
    position: fixed;
    top: 0;
    right: 0;
    margin: 10px;
    color: #47b784;
    border-radius: 50%;
    border: 1px solid #cccccc81;
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
  }

  video {
    margin: 50px;
    width: 100%;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/v2/story-edit-view/timeline-components/video.vue